import React, {PureComponent} from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import * as TextManager from "../modules/languages/TextManager";
//import { Document, Page } from 'react-pdf/dist/entry.noworker';

export default class DropFiles extends PureComponent {
    static propTypes = {
        customHeight: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    removeFile(index, e) {
        e.preventDefault();
        this.props.onChange(this.props.files.filter((val, i) => i !== index));
    }

    handleDropRejected(args) {
        console.debug('reject', args)
    }

    render() {
        const files = this.props.files;

        return (
            <div className={`dropzone dropzone--single${this.props.customHeight ? ' dropzone--custom-height' : ''}`}>
                <Dropzone
                    className='dropzone__input'
                    accept='image/jpeg, image/png, .pdf'
                    name={this.props.name}
                    multiple={this.props.multi}
                    onDropRejected={(args) => this.handleDropRejected(args)}
                    onDrop={(filesToUpload) => {
                        this.props.onChange(filesToUpload);
                    }}
                >
                    {(!files || files.length === 0) &&
                    <div className='dropzone__drop-here'><span
                        className='lnr lnr-upload'/>{TextManager.getCurrentTextResource().Text.dropFileHere}</div>}
                </Dropzone>
                {files && Array.isArray(files) && files.length > 0 &&

                files.map((file, index) => {
                    return <div key={index} className='dropzone__img'>
                        <img src={file.preview} alt='drop-img'/>
                        <p className='dropzone__img-name'>{files.name}</p>
                        <button className='dropzone__img-delete' onClick={(e) => this.removeFile(index, e)}>
                            {TextManager.getCurrentTextResource().Text.remove}
                        </button>
                    </div>
                    }
                )}

                {((!files || !Array.isArray(files) || files.length === 0) && this.props.originalUrl) &&

                <div className="dropzone.dropzone--custom-height">
                    <img style={{maxWidth: "100%", width: "200px", height: "auto"}} src={this.props.originalUrl}
                         alt='drop-img'/>
                </div>
                }
            </div>
        )
    }
}